import axios, {AxiosRequestConfig} from 'axios';
import {
  aboStore,
  customPortalState,
  globalStore,
  isPortalMigros,
  shopConfigState,
  shopIntegrationState,
} from './store';
import langFr from '../lang/fr.json';
import langEn from '../lang/en.json';
import langDe from '../lang/de.json';
import langIt from '../lang/it.json';
import langEs from '../lang/es.json';
import MessageFormat from 'messageformat';
import {Env} from '@stencil/core';
import {createStore} from '@stencil/store';
import {DateTime} from 'luxon';

export const endpoint_api = Env.SHOP_API_ENDPOINT;
export const endpoint_assets = Env.SHOP_ASSET_ENDPOINT;
export const endpoint_storage = Env.STORAGE_URL;
export const endpoint_portal = Env.PORTAL_ENDPOINT;
export const endpoint_api_v2 = Env.API_V2_ENDPOINT;
export const app_token = Env.APP_TOKEN;

// for overload
// const endpoints = [
//   'https://etickets.infomaniak.com',
//   'https://etickets.infomaniak.com'
// ]
// export const endpoint_api = endpoints[Math.round(Math.random()*1)];
export const I_SELECT_SEAT_ADMIN = 0;
export const I_SELECT_SEAT_RESELLER = 1;
export const I_SELECT_SEAT_CUSTOMER = 2;
export const I_SELECT_SEAT_DISABLED = 3;

export const I_TARIFF_TYPE_OPEN = 'open';

export const HC_AJOIE_PERIOD_ID = 20766;
export const I_ABO_PERIOD_SERVETTE = 22077;

function CustomEventTarget() {
  var target = document.createTextNode('');
  this.addEventListener = target.addEventListener.bind(target);
  this.removeEventListener = target.removeEventListener.bind(target);
  this.dispatchEvent = target.dispatchEvent.bind(target);
}

CustomEventTarget.prototype = EventTarget.prototype;

class ShopStorage {
  storePeriod = null;
  shopId = null;
  constructor(storePeriod, shopId) {
    this.storePeriod = storePeriod;
    this.shopId = shopId;
  }

  get(key?, def?): any {
    const infomaniakTicketing = JSON.parse(localStore.getItem('infomaniakTicketing')) as any;
    const periodId = shopIntegrationState.isProfile ? 'profile' : this.storePeriod() || Object.values((infomaniakTicketing || {})[this.shopId] || []).reduce((acc: any, val) => {
      return (acc == 0 && val["period-id"]) ? val['period-id'] : (acc + 0)
    }, 0);
    if (key == 'browser_uuid') {
      return get(infomaniakTicketing || {}, `${key}`, def);
    }
    return get(infomaniakTicketing || {}, key ? `${this.shopId}.${periodId}.${key}` : this.shopId, def);
  }

  remove(key): any {
    const periodId = shopIntegrationState.isProfile ? 'profile' : this.storePeriod();
    let infomaniakTicketing = JSON.parse(localStore.getItem('infomaniakTicketing')) as any;
    delete infomaniakTicketing[this.shopId][periodId][key];
    localStore.setItem('infomaniakTicketing', JSON.stringify(infomaniakTicketing));
  }

  emptyAll(exceptKeys = ['browser_uuid']): any {
    const infomaniakTicketing = JSON.parse(localStore.getItem('infomaniakTicketing')) || {};
    const dataToKeep = {};

    for (const path of exceptKeys) {
      const value = get(infomaniakTicketing, path);
      if (value !== undefined) {
        set(dataToKeep, path, value);
      }
    }

    localStore.setItem('infomaniakTicketing', JSON.stringify(dataToKeep));
    return this;
  }

  logoutAllConnectedPeriod(){
    const storedValue = localStore.getItem('infomaniakTicketing');

    if (!storedValue) return;

    const ticketings = JSON.parse(storedValue);

    Object.values(ticketings).forEach(periodMap => {
      Object.values(periodMap).forEach(period => {
        if (period && typeof period === 'object') {
          delete period.user_token;
        }
      });
    });

    localStore.setItem('infomaniakTicketing', JSON.stringify(ticketings));
  }

  set(key, value) {
    const periodId = shopIntegrationState.isProfile ? 'profile' : this.storePeriod();
    const infomaniakTicketing = JSON.parse(localStore.getItem('infomaniakTicketing')) as any;
    let newData = '';
    if (key == 'browser_uuid') {
      newData = set(infomaniakTicketing || {}, `${key}`, value);
    } else {
      newData = set(infomaniakTicketing || {}, `${this.shopId}.${periodId}.${key}`, value);
    }
    localStore.setItem('infomaniakTicketing', JSON.stringify(newData));
    return this;
  }
}


export class Utils {
  public shopId: string;
  public router = null;
  public observable = new CustomEventTarget();
  public route = null;
  public storage = null
  public profileStorage = null
  /**
   * @deprecated We should use a global store, see store.ts
   */
  public store = createStore({
    cart: null,
    credits: null,
    pass: null,
    config: null,
    curr: null,
    datepickerContainer: null,
  });

  constructor(shopId) {
    this.shopId = shopId;
    shopConfigState.code = shopId;
    this.storage = new ShopStorage(()=>this.storePeriod(), shopId);
    this.profileStorage = new ShopStorage(()=>'profile', 'profile');
  }

  isItiMobile() {
    return /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  }

  getEnableCookieLink() {
    if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
      return 'https://help.opera.com/en/latest/web-preferences/#cookies';
    } else if (navigator.userAgent.indexOf("Chrome") != -1) {
      return 'https://support.google.com/accounts/answer/61416';
    } else if (navigator.userAgent.indexOf("Safari") != -1) {
      return 'https://support.apple.com/fr-fr/guide/safari/sfri11471/mac';
    } else if (navigator.userAgent.indexOf("Firefox") != -1) {
      return 'https://support.mozilla.org/en-US/kb/websites-say-cookies-are-blocked-unblock-them';
    } else {
      return 'https://support.microsoft.com/en-us/office/enable-cookies-6b018d22-1d24-43d9-8543-3d35ddb2cb52';
    }
  }

  http(method, url, data?, options = {}, forcedEndpoint = null): Promise<any> {
    const cart = this.store.get('cart');
    let lang = language()
    if (cart) {
      let languages = cart?.languages;
      if (!languages && cart?.all_languages) {
        languages = Object.values(cart?.all_languages);
      }
      if (languages) {
        let current = languages.filter(l => l.sLocaleShort == lang);
        if (!current[0]?.sLocaleShort) {
          lang = cart.language?.short;
        }
      }
    }
    const headers = {
      language: lang,
      currency: this.currency(),
      'Ik-Custom-Portal-Id': customPortalState.id,
      'kueue': sessionStorage.getItem('kueue') || '',
      'shop-origin': shopIntegrationState.isEmbedded ? 'integrated' :'portal'
    };

    if(customPortalState.id){
      // Dans le cas d'un custom portal, si on on est conecté au profil on a forcement un compte sur le groupe du custom portal
      // donc on peu se permettre de le transmettre au shop
      const profil_token = this.profileStorage.get('user_token');
      if(profil_token){
        this.storage.set('user_token', profil_token)
      }
    }

    const uuid = this.storage.get('uuid');
    const browser_uuid = this.storage.get('browser_uuid');
    const user_token = this.storage.get('user_token');
    const pass_token = this.storage.get('pass_token');
    const period_id = this.storePeriod();
    if (period_id) {
      headers['period-id'] = period_id;
    }
    if (cart && cart.period) {
      headers['period-id'] = cart.period;
    }
    if (uuid) {
      headers['order'] = uuid;
    }
    if (browser_uuid) {
      headers['browser-uuid'] = browser_uuid;
    }
    if (user_token) {
      headers['Authorization'] = user_token;
    }
    if (pass_token) {
      headers['Authorization-pass'] = pass_token;
    }
    url = `${forcedEndpoint || endpoint_api}/shop/${this.shopId}${url}`;

    if (method === 'get') {
      let params = data;
      return axios.get(url, {
        params,
        headers,
        withCredentials: true, ...options
      } as AxiosRequestConfig).then(response => response.data);
    }

    return axios({
      url,
      method,
      data,
      headers,
      withCredentials: true, ...options
    } as AxiosRequestConfig).then(response => response.data);
  }

  storePeriod(value?) {
    if (value) {
      sessionStore.setItem(`ike.${this.shopId}.period_id`, value);
    }
    if (localStore.getItem("infomaniakTicketing")) {
      let periods = Object.keys(JSON.parse(localStore.getItem("infomaniakTicketing"))[this.shopId] || {});
      let defaultPeriodId = periods[0];
      if (!sessionStore.getItem(`ike.${this.shopId}.period_id`) && defaultPeriodId && periods.filter(key => key != "null").length == 1) {
        sessionStore.setItem(`ike.${this.shopId}.period_id`, defaultPeriodId);
        return defaultPeriodId;
      }
    }
    return sessionStore.getItem(`ike.${this.shopId}.period_id`);
  }

  storeCartContent(itemCount: number): void {
    sessionStore.setItem('ike_cart_content', JSON.stringify({
      item_count: itemCount,
      last_shop_code: shopConfigState.code
    }));
  }

  shopIsEuro() {
    return this.storage.get('curr') == 2 ? true : false;
  }

  currency(value?) {
    let curr = this.storage.get('curr');
    if (value) {
      if (typeof value === "function") {
        value(curr)
        return this.store.onChange('curr', value);
      }
      this.store.set('curr', value);
      this.storage.set('uuid', '');
      return this.storage.set('curr', value);
    }
    return curr;
  }

  logout() {
    this.http('get', '/user/logout').then(cart => {
      this.storage.logoutAllConnectedPeriod()
      document.dispatchEvent(new CustomEvent('ike_notification', {'detail': ['success', translate("Deconnexion reussi")]}));
      document.dispatchEvent(new CustomEvent('ike_user_logout', {'detail': cart}));
      window.location.reload()
    }).catch(() => {
      document.dispatchEvent(new CustomEvent('ike_notification', {'detail': ['error', translate("Une erreur est survenue")]}));
    });
  }

  goTo(path: string) {
    path = path.startsWith('/') ? path : `/${path}`; //Prevent goTo usage without '/' prefix
    const absolutePath = this.router.getOptions().basePath + path;
    this.router.navigate(absolutePath);
    document.dispatchEvent(new CustomEvent('ike_page_changed', {'detail': {path: `/${absolutePath?.split('/')[1]}`}}));
  }

  cart(key?) {
    const cart = this.store.get('cart');
    if (typeof key === "function") {
      key(cart);
      return this.store.onChange('cart', key);
    } else if (key) {
      return get(cart, key);
    }
    return cart;
  }

  credits(key?) {
    let credits = null;
    if (localStore.getItem(this.storage.get('uuid')) && localStore.getItem(this.storage.get('uuid')) != 'undefined') {
      credits = JSON.parse(localStore.getItem(this.storage.get('uuid')));
    }

    // const credits = this.store.get('credits');
    if (typeof key === "function") {
      key(credits);
      return this.store.onChange('credits', key);
    } else if (key) {
      return get(credits, key);
    }
    return credits;
  }

  abo(key?) {
    const abo = aboStore.get('abo');
    if (typeof key === "function") {
      key(abo);
      return aboStore.onChange('abo', key);
    } else if (key) {
      return get(abo, key);
    }
    return abo;
  }

  pass(key?) {
    const pass = this.store.get('pass');
    if (typeof key === "function") {
      key(pass);
      return this.store.onChange('pass', key);
    } else if (key) {
      return get(pass, key);
    }
    return pass;
  }

  goToAboSelection(code) {
    var bodyFormData = new FormData();
    bodyFormData.append('sCodeBar', code);
    this.http('post', `/user/use-pass`, bodyFormData).then((res) => {
      if (Number(res.bValid) !== 0) {
        if (Object.values(res.cart.passes || []).some((pass: any) => pass.countTickets !== pass.passCategory.maxPassCount)) {
          this.store.set('cart', res.cart);
          this.storage.set('uuid', res.cart.uuid);
          this.goTo('/abo/' + res.id + '/selection')
        } else {
          document.dispatchEvent(new CustomEvent('ike_notification', {'detail': ['error', translate('Votre pass est deja plein')]}));
        }
      } else {
        var event = new CustomEvent('ike_notification', {'detail': ['error', res.sText]});
        document.dispatchEvent(event);
      }
    }).catch(err => {
      if (err.response?.status === 400) {
        var event = new CustomEvent('ike_notification', {'detail': ['error', err.response.data]});
        document.dispatchEvent(event);
      } else {
        var event = new CustomEvent('ike_notification', {'detail': ['error', translate("Une erreur est survenue.")]});
        document.dispatchEvent(event);
      }
    });
  }

  config(key?) {
    const config = this.store.get('config');
    if (typeof key === "function") {
      key(config);
      return this.store.onChange('config', key);
    } else if (key) {
      return get(config, key);
    }
    return config;
  }

  checkUserLogin() {
    if (!this.storage.get('user_token')) {
      this.goTo('/login');
    }
  }

  isUserLogged() {
    return this.cart() && this.cart().customer && this.storage.get('user_token');
  }

  translate(key, data?) {
    const config = this.store.get('config');
    return translate(key, data, config.translations[key]);
  }

  handleSelectCurrency(value, cart) {
    let curr = cart.currencies.filter(l => l.id == value)[0];
    if (curr.id != cart.currency.id) {
      this.currency(curr.id)
      window.location.href = window.location.href
    }
  }

  applyBuyXGetYAvailable() {
    return this.http('post', '/cart/apply-x-get-y')
      .then(data => {
        this.store.set('cart', data.cart)
      })
      .catch(err => {
        if (err?.response?.status === 400) {
          var event = new CustomEvent('ike_notification', {'detail': ['error', err.response.data]});
        } else {
          var event = new CustomEvent('ike_notification', {'detail': ['error', translate("Une erreur est survenue.")]});
        }
        document.dispatchEvent(event);
      })
  }

  emptyCart(forceRelaod) {
    const previousCart = {...this.cart};

    this.http('post', '/cart/empty').then(data => {
      this.store.set('cart', data.cart)
      this.storage.set('uuid', '');
      // remove credits
      this.store.set('credits', '');
      localStore.setItem(this.storage.get('uuid'), '');
      document.dispatchEvent(new CustomEvent('ike_cart_empty', {'detail': data.cart}));
      document.dispatchEvent(new CustomEvent('ike_cart_delete', {
        'detail': {
          previousCart: previousCart,
          newCart: data.cart,
        }
      }));
      if (forceRelaod) {
        this.goTo('/')
      }
    });
  }

  getExchangeCountFee(credits): number {
    if (!credits?.ticketsCount) {
      return 0;
    }

    let positiveTicketsCount = 0;

    for (const eventId in credits.events) {
      const event = credits.events[eventId];

      for (const ticketId in event.tickets) {
        const ticket = event.tickets[ticketId];
        if (ticket.amount > 0) {
          positiveTicketsCount++;
        }
      }
    }

    return positiveTicketsCount;
  }
}

export function portalGroupPageUrl(groupUuid) {
  return `${baseUri()}/group/${groupUuid}`;
}

// return a random int in interval (inclusive)
export function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function groupBy(arr, f) {
  return arr.reduce((out, val) => {
    let by = typeof f === 'function' ? '' + f(val) : val[f];
    (out[by] = out[by] || []).push(val);
    return out;
  }, {});
}

export function language(value?): string {
  let lang = localStore.getItem('infomaniakTicketingLang');
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  if (urlParams.has('sLocale')) {
    lang = urlParams.get('sLocale');
    window.history.pushState('', '', window.location.href.split('?')[0]);
  }

  if (value) {
    if (typeof value === "function") {
      value(lang)
      globalStore.onChange('lang', value);
      return value;
    }

    globalStore.set('lang', value);
    localStore.setItem('infomaniakTicketingLang', value);
    return value;
  }

  if (!lang) {
    const htmlLang = document.getElementsByTagName('html')[0].getAttribute('lang');
    lang = localStore.getItem('infomaniakTicketingLang') || (htmlLang || navigator['language'] || navigator['userLanguage']).slice(0, 2) || 'fr';
    globalStore.set('lang', lang);
  }

  return lang;
}

export type LanguageCode = 'fr' | 'de' | 'en' | 'it' | 'es';
export type LanguageId = 1 | 2 | 3 | 4 | 5;

export function getLanguageId(code: LanguageCode): LanguageId {
  switch(code) {
    case 'fr':
      return 1;
    case 'de':
      return 2;
    case 'en':
      return 3;
    case 'it':
      return 4;
    case 'es':
      return 5;
  }
}

export function getLanguageCode(id: LanguageId): LanguageCode {
  switch(id) {
    case 1:
      return 'fr';
    case 2:
      return 'de';
    case 3:
      return 'en';
    case 4:
      return 'it';
    case 5:
      return 'es';
  }
}

let missingTranslations = [];

export function translate(key, data?, text?) {
  const langs = {
    fr: langFr,
    en: langEn,
    de: langDe,
    it: langIt,
    es: langEs,
  };
  let lang = language();
  const mf = new MessageFormat(lang);
  if (!langs.hasOwnProperty(lang)) {
    lang = 'fr';
  }
  if (!text) {
    text = langs[lang][key]
  }
  if (!text) {
    text = key;
    if (currentEnvironment() === 'dev') {
      if (missingTranslations.indexOf(key) === -1) {
        missingTranslations.push(key)
        console.error(`missing translation : %c${key}`, "color:black; background:white; font-family: monospace; padding: 5px;")
      }
      text = "!" + text;
    }
  }
  return data ? mf.compile(text)(data) : text
}

export const get = (obj, path, defValue?) => {
  if (!path) return undefined
  const pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])+/g)
  return (
    pathArray.reduce((prevObj, key) => prevObj && prevObj[key], obj) || defValue
  )
}

export const set = (obj, path, value) => {
  const pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])+/g)

  pathArray.reduce((acc, key, i) => {
    if (acc[key] === undefined) acc[key] = {}
    if (i === pathArray.length - 1) acc[key] = value
    return acc[key]
  }, obj)

  return obj;
}

export const cut_cents = (number, currencyString = '') => {
  let isEuro = currencyString == 'EUR';

  number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
  var n = !isFinite(+number) ? 0 : +Math.abs(number),
    prec = 2;

  // Fix for IE parseFloat(0.55).toFixed(0) = 0;
  function toFixedFix(n, prec) {
    var k = Math.pow(10, prec);
    return '' + (Math.round(n * k) / k).toFixed(prec);
  }

  var s = toFixedFix(n, prec).split('.');
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, '\'');
  }
  let euroPoint = '.';
  if (s[1] == '00') {
    s[1] = isEuro ? '' : '-';
    euroPoint = '';
  } else if (s[1].length < prec) {
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  const amountWithSymbol = isEuro ? s.join(euroPoint) + ' €' : currencyString + ' ' + s.join('.');
  const prefix = number < 0 ? '- ' : '';
  return prefix + amountWithSymbol
}

export const checkEmail = (email) => {
  const REGEX_EMAIL = /^(?!(?:(?:\x22?\x5C[\x00-\x7E]\x22?)|(?:\x22?[^\x5C\x22]\x22?)){255,})(?!(?:(?:\x22?\x5C[\x00-\x7E]\x22?)|(?:\x22?[^\x5C\x22]\x22?)){65,}@)(?:(?:[\x21\x23-\x27\x2A\x2B\x2D\x2F-\x39\x3D\x3F\x5E-\x7E]+)|(?:\x22(?:[\x01-\x08\x0B\x0C\x0E-\x1F\x21\x23-\x5B\x5D-\x7F]|(?:\x5C[\x00-\x7F]))*\x22))(?:\.(?:(?:[\x21\x23-\x27\x2A\x2B\x2D\x2F-\x39\x3D\x3F\x5E-\x7E]+)|(?:\x22(?:[\x01-\x08\x0B\x0C\x0E-\x1F\x21\x23-\x5B\x5D-\x7F]|(?:\x5C[\x00-\x7F]))*\x22)))*@(?:(?:(?!.*[^.]{64,})(?:(?:(?:xn--)?[a-z0-9]+(?:-[a-z0-9]+)*\.){1,126}){1,}(?:(?:[a-z][a-z0-9]*)|(?:(?:xn--)[a-z0-9]+))(?:-[a-z0-9]+)*)|(?:\[(?:(?:IPv6:(?:(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){7})|(?:(?!(?:.*[a-f0-9][:\]]){7,})(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,5})?::(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,5})?)))|(?:(?:IPv6:(?:(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){5}:)|(?:(?!(?:.*[a-f0-9]:){5,})(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,3})?::(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,3}:)?)))?(?:(?:25[0-5])|(?:2[0-4][0-9])|(?:1[0-9]{2})|(?:[1-9]?[0-9]))(?:\.(?:(?:25[0-5])|(?:2[0-4][0-9])|(?:1[0-9]{2})|(?:[1-9]?[0-9]))){3}))\]))$/;
  // const REGEX_EMAIL = /^([a-z]|[0-9]|_|&|(\.(?!\.))|\-)+@([a-z-\x80-\xff]|[0-9]|(\.(?!\.))|(\-(?!\.)))+\.[a-z]+$/i;
  if (!REGEX_EMAIL.test(email)) {
    return false;
  }
  return true;
}

/**
 * here, the index maps to the error code returned from getValidationError - see intl-tel-input doc
 * @param {number} errorCode
 * @return {string}
 */
export const telInputErrorMessages = (errorCode: number): string => {
  return [
    translate("Numero de telephone invalide"),
    translate("Code pays invalide"),
    translate("Trop court"),
    translate("Trop long"),
    translate("Numero invalide"),
    translate("Numero invalide")
  ][errorCode]
};


export const localStore = storageFactory(() => localStorage);
export const sessionStore = storageFactory(() => sessionStorage);


/* ISC License (ISC). Copyright 2017 Michal Zalecki */

export function storageFactory(getStorage: () => Storage): Storage {
  let inMemoryStorage: { [key: string]: string } = {};

  function isSupported() {
    try {
      const testKey = "__some_random_key_you_are_not_going_to_use__";
      getStorage().setItem(testKey, testKey);
      getStorage().removeItem(testKey);
      return true;
    } catch (e) {
      return false;
    }
  }

  function clear(): void {
    if (isSupported()) {
      getStorage().clear();
    } else {
      inMemoryStorage = {};
    }
  }

  function getItem(name: string): string | null {
    if (isSupported()) {
      return getStorage().getItem(name);
    }
    if (inMemoryStorage.hasOwnProperty(name)) {
      return inMemoryStorage[name];
    }
    return null;
  }

  function key(index: number): string | null {
    if (isSupported()) {
      return getStorage().key(index);
    } else {
      return Object.keys(inMemoryStorage)[index] || null;
    }
  }

  function removeItem(name: string): void {
    if (isSupported()) {
      getStorage().removeItem(name);
    } else {
      delete inMemoryStorage[name];
    }
  }

  function setItem(name: string, value: string): void {
    if (isSupported()) {
      getStorage().setItem(name, value);
    } else {
      inMemoryStorage[name] = String(value); // not everyone uses TypeScript
    }
  }

  function length(): number {
    if (isSupported()) {
      return getStorage().length;
    } else {
      return Object.keys(inMemoryStorage).length;
    }
  }

  return {
    getItem,
    setItem,
    removeItem,
    clear,
    key,
    get length() {
      return length();
    },
    telInputErrorMessages,
  };
}

export function isTextEmpty(htmlString: string): boolean {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  const textContent = doc.body.textContent || '';
  return textContent.trim() === '';
}

export function dateSqlToIso(date: string): string {
  return DateTime.fromSQL(date).toISO()
}

export function dateToString(date: Date): string {
  const year = date.getFullYear();

  let month: number | string = date.getMonth() + 1;
  let day: number | string = date.getDate();

  if (month < 10) month = '0' + month;
  if (day < 10) day = '0' + day;

  return `${year}-${month}-${day}`;
}

export function checkIsPassValid(pass): string | boolean {
  if (pass.passCategory.minEventSale && !pass.offer_option) {
    if (pass.countEvents < pass.passCategory.minEventSale) {
      return 'not_enough_events';
    }
  }
  if ((!pass || pass.countTickets < pass.passCategory.minPassCount) && !pass.offer_option) {
    return 'not_enough_tickets';
  }
  return true;
}


export function getEventDateBounds(event, bound = 'end'): string {
  if (bound === 'end') {
    if (event.date_last && event.date_last !== event.date) {
      return event.date_last;
    }
    return event.end ?? event.date;
  }

  if (bound === 'start') {
    if (event.date_first && event.date_first !== event.date) {
      return event.date_first
    }
    return event.date;
  }
}

export function getDateDisplay(startDate, endDate?): string {
  if (endDate && startDate !== endDate) {
    if (DateTime.fromSQL(startDate).hasSame(DateTime.fromSQL(endDate), 'day')) {
      return translate("Le {date}, de {start} a {end}", {
        date: DateTime.fromSQL(startDate).toLocaleString(DateTime.DATE_FULL),
        start: DateTime.fromSQL(startDate).toLocaleString(DateTime.TIME_SIMPLE),
        end: DateTime.fromSQL(endDate).toLocaleString(DateTime.TIME_SIMPLE)
      })
    } else {
      return translate("Du {start} au {end}", {
        start: DateTime.fromSQL(startDate).toLocaleString(DateTime.DATE_FULL),
        end: DateTime.fromSQL(endDate).toLocaleString(DateTime.DATE_FULL),
      })
    }
  } else {
    return translate("{date} à {hour}", {
      date: DateTime.fromSQL(startDate).toFormat('EEEE d MMMM yyyy'),
      hour: DateTime.fromSQL(startDate).toLocaleString(DateTime.TIME_SIMPLE),
    })
  }
}

export function seatToString(seat): string {
  if (!seat) {
    console.log('No seat data');
    return '';
  }

  if (!!seat.row) {
    if (!!seat.row.part) {
      return translate("{bloc} - Rangee {row} - Siege {seat}", {
        bloc: seat.row.part.name,
        row: seat.row.name,
        seat: seat.name,
      });
    } else {
      return translate("Rangee {row} - Siege {seat}", {
        row: seat.row.name,
        seat: seat.name,
      });
    }
  } else {
    return translate("Siege {seat}", {
      seat: seat.name,
    });
  }
}

export function httpV2<T = any>(method, url, data?, options = {}): Promise<T> {

  const uri = endpoint_api_v2 + url;
  const headers = {
    lang: language(),
    Authorization: `Bearer ${app_token}`
  };

  if (method === 'get') {
    return axios.get(uri, {
      data,
      params: data,
      headers,
      withCredentials: true, ...options
    } as AxiosRequestConfig).then(response => response.data);
  }
  return axios({
    uri,
    method,
    data,
    headers,
    withCredentials: true, ...options
  } as AxiosRequestConfig).then(response => response.data);
}

export function slugify(text) {
  return text
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-')
}

export function formatDateRange(startDate: DateTime, endDate: DateTime): string {
  const formatDay = 'd';
  const formatDayMonth = 'd MMMM';
  const formatDayMonthYear = 'd MMMM yyyy';

  let formattedStartDate: string, formattedEndDate: string;

  if (startDate.hasSame(endDate, 'day')) {
    return translate('Le {date}', {
      date: startDate.toFormat(formatDayMonthYear)
    });
  } else if (startDate.hasSame(endDate, 'year') && startDate.hasSame(endDate, 'month')) {
    formattedStartDate = startDate.toFormat(formatDay);
    formattedEndDate = endDate.toFormat(formatDayMonthYear);
  } else if (startDate.hasSame(endDate, 'year')) {
    formattedStartDate = startDate.toFormat(formatDayMonth);
    formattedEndDate = endDate.toFormat(formatDayMonthYear);
  } else {
    formattedStartDate = startDate.toFormat(formatDayMonthYear);
    formattedEndDate = endDate.toFormat(formatDayMonthYear);
  }

  return translate('Du {startDate} au {endDate}', {
    startDate: formattedStartDate,
    endDate: formattedEndDate
  });
}

/**
 * Return the correct portal endpoint depending on custom portals
 */
export function baseUri(): string {
  if (isPortalMigros()) {
    return endpoint_portal.replace(/:\/\/(?!migros\.)(?:portal\.)?/, '://migros.');
  }
  return endpoint_portal;
}

export type Environment = 'prod' | 'dev'

export function currentEnvironment(): Environment {
  return endpoint_api == 'https://etickets.infomaniak.com' ? 'prod' : 'dev'
}
